import { BaseIconHelper } from './base.icon.helper';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { IconProperties } from '../../../../ui/gzIcon/types';

export class NetworkTreeIconHelper extends BaseIconHelper {
  public static getIconForProtectedEntity(protectedEntity: ProtectedEntity): IconProperties {
    switch (protectedEntity.type) {
      case Constants.Companies.TYPE_COMPANY:
        return { icon: protectedEntity.specifics.rights?.manageCompanies ? 'ds-icon-company' : 'ds-icon-customer' };
      case Constants.Companies.TYPE_COMPANIES_COLLECTION:
        return { icon: 'ds-icon-companies' };
      case Constants.Companies.TYPE_COMPANY_NETWORK:
        return { icon: 'ds-icon-network' };
      case Constants.ProtectedEntities.CONTAINERS.TYPE_HOST:
        return { icon: 'ds-icon-container_hosts' };
      case Constants.ProtectedEntities.EPS.TYPE_AWS_GROUP:
        return { icon: 'ds-icon-Amazon-EC2-group' };
      case Constants.ProtectedEntities.EPS.TYPE_AWS_ACCOUNT:
        return { icon: 'ds-icon-integration-group' };
      case Constants.ProtectedEntities.EPS.TYPE_AWS_REGION:
        return { icon: 'ds-icon-aws-regions' };
      case Constants.ProtectedEntities.EPS.TYPE_AWS_AZ:
        return { icon: 'ds-icon-aws-availability-zones' };
      case Constants.ProtectedEntities.EPS.VMWARE_COLLECTION:
        return { icon: 'ds-icon-vmware-collection' };
      case Constants.ProtectedEntities.EPS.VMWARE_CENTER:
        return { icon: 'ds-icon-vmware-center' };
      case Constants.ProtectedEntities.EPS.VMWARE_DATACENTER:
        return { icon: 'ds-icon-vmware-datacenter' };
      case Constants.ProtectedEntities.EPS.VMWARE_HOST_SYSTEM:
        return { icon: 'ds-icon-vmware-host' };
      case Constants.ProtectedEntities.EPS.VMWARE_RESOURCE_POOL:
      case Constants.ProtectedEntities.EPS.VMWARE_CLUSTER_COMPUTE_RESOURCE:
        return { icon: 'ds-icon-vmware-cluster-compute-resource' };
      case Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_APP:
        return { icon: 'ds-icon-vmware-virtual-app' };
      case Constants.ProtectedEntities.EPS.VMWARE_COMPUTE_RESOURCE:
      case Constants.ProtectedEntities.EPS.VMWARE_FOLDER:
      default:
        return { icon: 'ds-icon-group' };
    }
  }
}
